export enum InputVariant {
  STANDARD = 'standard',
  FILLED = 'filled',
  OUTLINED = 'outlined',
}